/* PAPAPATTES : en-tête sticky compact (2026-10-14) — voir pp-header-compact.css */
(function () {
  var root = document.documentElement;
  var sh = document.querySelector('.section-header');
  if (!sh) return;

  var ON_AT = 100, OFF_AT = 20;
  var compact = false, lastY = window.pageYOffset || 0;

  function setBodyVars() {
    root.style.setProperty('--header-height', sh.offsetHeight + 'px');
    syncStickyTop();
  }

  // Les barres sticky de la fiche (fil d'Ariane, pagination) se collent sous la partie
  // RÉELLEMENT visible de l'en-tête : bandeau réseaux masqué en condensé, en-tête masqué
  // en mobile quand on descend. Sans ça, un vide laisse apparaître le contenu au-dessus.
  function syncStickyTop() {
    if (!compact) { root.style.removeProperty('--pp-bc-top'); return; }
    var hidden = root.classList.contains('pp-hc-hide');
    root.style.setProperty('--pp-bc-top', (hidden ? 0 : sh.offsetHeight) + 'px');
  }

  // Le flux total reste constant : la hauteur perdue est restituée en marge basse => aucun saut de contenu.
  function applyCompact(on) {
    var before = sh.offsetHeight;
    root.classList.toggle('pp-hc', on);
    if (!on) root.classList.remove('pp-hc-hide', 'pp-hc-search');
    var after = sh.offsetHeight;
    sh.style.setProperty('margin-bottom', on ? Math.max(0, before - after) + 'px' : '', 'important');
    compact = on;
    setBodyVars();
    syncSearchBtn();
  }

  function menuOpen() {
    return !!(sh.querySelector('details[open]') || document.body.classList.contains('overflow-hidden') ||
      document.querySelector('cart-drawer.active, cart-drawer.is-open'));
  }

  // Réglages de la section header : oui/non + seuil en % de la hauteur d'écran, séparés mobile / desktop.
  function thresholdPx() {
    var st = document.querySelector('sticky-header');
    if (!st) return ON_AT;
    var mob = window.innerWidth < 750;
    if (st.getAttribute(mob ? 'data-pp-hide-mobile' : 'data-pp-hide-desktop') !== 'true') return null;
    var pct = parseFloat(st.getAttribute(mob ? 'data-pp-hide-mobile-pct' : 'data-pp-hide-desktop-pct'));
    pct = isNaN(pct) ? 0 : Math.min(500, Math.max(0, pct));
    return window.innerHeight * pct / 100;
  }

  function onScroll() {
    var y = window.pageYOffset || 0;
    var t = thresholdPx(); // null = désactivé
    if (t === null) { if (compact) applyCompact(false); }
    else if (!compact && y > t) applyCompact(true);
    else if (compact && y <= Math.min(OFF_AT, t / 2)) applyCompact(false);

    // Seule la bande réseaux se masque ; le menu reste toujours visible.
    root.classList.remove('pp-hc-hide');
    lastY = y;
    syncStickyTop();
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  window.addEventListener('resize', function () {
    if (compact) { applyCompact(false); onScroll(); }
    else setBodyVars();
  });

  // Bouton recherche (desktop condensé) : ouvre / ferme la barre large en surimpression.
  var btn = null;
  function ensureBtn() {
    if (btn) return btn;
    var icons = sh.querySelector('.header__icons');
    if (!icons || !sh.querySelector('.header__search-bar-row')) return null;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pp-hc-search-btn';
    btn.setAttribute('aria-label', 'Rechercher');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';
    icons.insertBefore(btn, icons.firstChild);
    btn.addEventListener('click', function () {
      var open = root.classList.toggle('pp-hc-search');
      btn.setAttribute('aria-expanded', String(open));
      if (open) {
        var input = sh.querySelector('.header__search-bar-row input[type="search"], .header__search-bar-row input');
        if (input) setTimeout(function () { input.focus(); }, 30);
      }
    });
    return btn;
  }
  function syncSearchBtn() {
    var b = ensureBtn();
    if (b && !root.classList.contains('pp-hc-search')) b.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('pp-hc-search')) {
      root.classList.remove('pp-hc-search');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    }
  });
  document.addEventListener('click', function (e) {
    if (root.classList.contains('pp-hc-search') && !e.target.closest('.header__search-bar-row, .pp-hc-search-btn')) {
      root.classList.remove('pp-hc-search');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  });

  // Desktop : le dernier bouton des réseaux sociaux s'aligne sur la fin du panier.
  function alignSocial() {
    var soc = document.querySelector('.pp-top-bar__social');
    var cart = sh.querySelector('.header__icon--cart');
    if (!soc || !cart) return;
    soc.style.removeProperty('margin-right');
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    var items = soc.querySelectorAll('.pp-top-bar__icon');
    var last = items[items.length - 1];
    if (!last) return;
    var diff = last.getBoundingClientRect().right - cart.getBoundingClientRect().right;
    if (Math.abs(diff) > 0.5) {
      var cur = parseFloat(getComputedStyle(soc).marginRight) || 0;
      soc.style.setProperty('margin-right', (cur + diff) + 'px', 'important');
    }
  }
  window.addEventListener('resize', alignSocial);
  window.addEventListener('load', alignSocial);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(alignSocial);
  alignSocial();

  ensureBtn();
  onScroll();
})();
